module.exports = __webpack_public_path__ + "img/fondo_login.f891aec7.jpg";